import React from "react";
import Image from "next/image";
import { RiArrowRightSLine } from "react-icons/ri";

interface FeatureCardProps {
    title: string;
    description: string;
    href: string;
    linkText: string;
    image: string;
}

const FeatureCard: React.FC<FeatureCardProps> = (props) => {
    const { title, description, href, linkText, image } = props;
    return (
        <section className="py-10 lg:px-0 px-5" style={{ background: "linear-gradient(180deg, #E5F3FF 0%, #FFF 100%)" }}>
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-center">
                <div className="flex flex-col lg:w-1/2 items-center lg:items-start mb-6">
                    <h2 className="font-semibold text-4xl text-gray-700">{title}</h2>
                    <p className="font-normal text-base text-gray-700 mt-3 text-center lg:text-left">{description}</p>
                    <div className="flex justify-start items-center  mt-6">
                        <a href={href} className="flex underline font-medium text-blue-500 text-base">
                            {linkText}
                        </a>
                        <RiArrowRightSLine className="text-blue-500" size={20} />
                    </div>
                </div>
                <Image height={80} width={500} src={image} alt="whatsapp icon" />
            </div>
        </section>
    );
};

export default FeatureCard;
